import {
	ACCOUNT_SETTINGS_ROUTE_ID,
	HOMEPAGE_ROUTE_ID,
	CAMPAIGNS_PAGE_ROUTE_ID,
	VIEWERS_PAGE_ROUTE_ID,
	PUBLISHERS_PAGE_ROUTE_ID,
	CREATORS_PAGE_ROUTE_ID,
	AGENCY_PUBLISHERS_LIST_ROUTE_ID,
	SIGN_UP_TOKEN_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import path from 'ramda/src/path'
import prop from 'ramda/src/prop'
import userRoleSelector from 'root/src/client/logic/auth/selectors/userRoleSelector'
import previousRouteSelector from 'root/src/client/logic/project/selectors/previousRouteSelector'
import { userGroups } from 'root/src/shared/constants/auth'
import noLoginRedirectSelector from 'root/src/client/logic/route/selectors/noLoginRedirectSelector'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { GET_BRAND_PRODUCTS, GET_DROP_EVENTS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { userEventsKey } from 'root/src/shared/constants/keys'
import getProfile from 'root/src/client/logic/app/selectors/getProfile'
import { profileRouteMap } from 'root/src/shared/constants/route'
import { isAllowedRoute } from 'root/src/shared/util/creatorRoutes'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'

const defaultRoute = { routeId: HOMEPAGE_ROUTE_ID }

const userGroupLoginMap = {
	[userGroups.brand]: async ({ dispatch }) => {
		const [
			productsRes, dropEventsRes,
		] = await Promise.all([
			dispatch(apiRequest(GET_BRAND_PRODUCTS, { limit: 1 })),
			dispatch(apiRequest(GET_DROP_EVENTS, {
				section: userEventsKey, pageItemLength: 1, // we only need to know if user has any event
			})),
		])

		return (
			path(['body', 'length'], productsRes)
			&& path(['body', 'items', 'length'], dropEventsRes)
		)
			? { routeId: CAMPAIGNS_PAGE_ROUTE_ID } : { routeId: ACCOUNT_SETTINGS_ROUTE_ID }
	},
	[userGroups.viewer]: redirectRoute => redirectRoute || ({ routeId: VIEWERS_PAGE_ROUTE_ID }),
	[userGroups.creator]: ({
		getState,
		redirectRoute,
	}) => {
		const state = getState()
		const profile = getProfile(state)

		if (!profile) {
			return defaultRoute
		}

		const { mnemonicId, platform } = profile

		if (isAllowedRoute(redirectRoute?.routeId)) {
			return redirectRoute
		}

		return {
			routeId: profileRouteMap[platform],
			routeParams: { recordId: mnemonicId },
		}
	},
	[userGroups.admin]: redirectRoute => redirectRoute || defaultRoute,
	[userGroups.agency]: () => ({ routeId: AGENCY_PUBLISHERS_LIST_ROUTE_ID }),
	[userGroups.agencyAccountManager]: () => ({ routeId: AGENCY_PUBLISHERS_LIST_ROUTE_ID }),
}

export default async ({
	dispatch,
	getState,
	redirectRoute,
}) => {
	const state = getState()
	const userRole = userRoleSelector(state)

	const roleSpecificHandling = prop(userRole, userGroupLoginMap)
	const previousRoute = previousRouteSelector(state)
	const { routeId } = previousRoute
	const noLoginRedirect = noLoginRedirectSelector(state, { routeId })
	dispatch(displayModal(undefined))

	if (routeId
		&& !(routeId === PUBLISHERS_PAGE_ROUTE_ID
			|| routeId === HOMEPAGE_ROUTE_ID
			|| routeId === SIGN_UP_TOKEN_ROUTE_ID
			|| routeId === CREATORS_PAGE_ROUTE_ID)
		&& !noLoginRedirect) {
		return previousRoute
	}

	return roleSpecificHandling({
		dispatch,
		getState,
		redirectRoute,
	})
}
